'use client'

import { useState, useEffect } from 'react'
import { PATHWAY } from '@/modules/httpService'

function ClientSide ({ id }: { id: string }) {
  const [isPosted, setIsPosted] = useState<boolean>(false)
  const [isUpdating, setIsUpdating] = useState<boolean>(false)

  async function markAsRead (id: string) {
    const referrer = document.referrer
    await PATHWAY.post(`/posts/${id}/readers`, { status: 'read' }, {
      headers: {
        'X-Referer': referrer
      }
    })

    setIsPosted(true)
  }

  useEffect(() => {
    if (!isPosted && !isUpdating) {
      setIsUpdating(true)

      // update the API with the post
      markAsRead(id)
    }
  }, [])

  return (
    <></>
  )
}

export default ClientSide
